import { parseTemplate } from "url-template";
import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { RequestInit } from "atoms/models";

const autopopulateAddressTemplate = parseTemplate("ecommerce/autopopulateAddress{?street}");

let controller: AbortController | null = null;

export const autoPopulateAddress = async (street: string) => {
  // If there's an ongoing fetch operation, cancel it
  if (controller) {
    controller.abort();
  }

  // Create a new AbortController for the current fetch operation
  controller = new AbortController();
  const { signal } = controller;

  const baseUrl = getBaseUrl();
  const relativeUrl = autopopulateAddressTemplate.expand({ street });
  const input = new URL(relativeUrl, baseUrl).href;
  const headers = new Headers();
  headers.append("Accept", "application/json");
  const init: RequestInit = {
    ...getRequestWithTokenInformation("GET", headers),
    signal, // Pass the signal to the fetch options
  };

  try {
    const response = await window.fetch(input, init);
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    } else {
      const json = await response.json();
      return json;
    }
  } catch (error: any) {
    if (error.name === "AbortError") {
      // Fetch aborted, handle it if needed
      console.log("Fetch aborted");
    } else {
      // Other errors
      console.error(error);
      throw error;
    }
  } finally {
    // Do not reset the controller after fetch completes or aborts
    // This ensures that the previous request is only canceled when a new one is made
  }
};
